export default __webpack_public_path__ + "static/media/check-circle.edef1bcd.svg";